module.exports = __webpack_public_path__ + "static/bonifico1-a659d6a20e0f60a0a519f4734bf65dba.png";